"use client";

import { useEffect, useRef } from "react";

export type ClientAnalyticsEventDetail = {
  eventName: string;
  element?: {
    id?: string;
    name?: string;
    type?: string;
  };
  funnel?: string;
  step?: string;
  properties?: Record<string, unknown>;
};

export const ANALYTICS_CLIENT_EVENT = "mdsafar:analytics";

export function trackAnalyticsEvent(detail: ClientAnalyticsEventDetail) {
  window.dispatchEvent(
    new CustomEvent<ClientAnalyticsEventDetail>(ANALYTICS_CLIENT_EVENT, {
      detail,
    }),
  );
}

export function AnalyticsEventOnMount({
  eventName,
  element,
  funnel,
  step,
  properties,
}: ClientAnalyticsEventDetail) {
  const sentRef = useRef(false);

  useEffect(() => {
    if (sentRef.current) return;
    sentRef.current = true;

    trackAnalyticsEvent({
      eventName,
      element,
      funnel,
      step,
      properties,
    });
  }, [element, eventName, funnel, properties, step]);

  return null;
}
